import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'この画像の代替テキストがありません',
    noAnswers: '回答オプションがありません。次へをクリックして続行してください。',
    placeholder: '入力してください：',
    pleaseSelect: '以下を選択してください：',
    rotateLandscape: '画面の向きのロックを解除し、横向きに回転させてください。',
    rotatePortrait: 'お使いの端末を横から縦に回転させてください。',
    ir: {
      selectWebCam:
        'ウェブカメラ（利用可能な場合）を選択するか「参照」をクリックしてデバイスからアップロードしてください',
      noWebCam: 'ウェブカメラが検出されませんでした',
      accessCamUpload: 'カメラにアクセス／アップロード',
      browse: '参照',
      uploadPhoto: '写真をアップロード',
      instead: '（代替）',
      capture: 'キャプチャ',
      somethingWrong: '申し訳ありませんがエラーが発生しました。 しばらくしてから再度お試しください',
      couldntRead: '申し訳ありませんが、コードを読み取ることができませんでした。',
      couldntProcess: '申し訳ありませんが、画像を処理できませんでした。',
      moveOn: 'もう一度やり直すか写真を投稿してください',
      tryAgain: 'もう一度お試しください',
      dataReceived: 'データを受信しました！',
      enterManually: 'もう一度お試しいただくか下記に情報を手動で入力してください',
      positionQR: 'カメラの前にQRコードを配置して赤い枠組みに合わせるか、コンピュータからアップロードしてください。',
      analyzing: '画像の解析中です。お待ちください',
      submit: '送信',
      startOver: '撮り直す',
      allDone: '終了です！',
      cantAnalyze:
        'ご注意 - この画像はレンダリングできませんでした。再送信するか、より一般的な画像形式（JPG、PNG、GIF、BMP）を選択してください',
      wrongFormat:
        '申し訳ありませんが、このファイル形式はサポートされていません。サポートされている画像タイプ（JPG、PNG、GIF、BMP、TIFF、PDF、SVG）をアップロードしてください'
    },
    vr: {
      noWebCam: 'ウェブカメラが検出されませんでした',
      uploadVideo: '動画をアップロード',
      skip: 'スキップしますか？',
      accessCamUpload: 'カメラにアクセス／アップロード',
      browse: '参照',
      instead: '（代替）',
      or: 'または',
      stopRecording: '録画を停止する',
      willBeStopped: '録画は5分後に停止します',
      stopOnDone: '回答を終えたら録画を停止してください。',
      record: 'レコーディング',
      somethingWrong: '申し訳ありませんがエラーが発生しました。 しばらくしてから再度お試しください',
      microphone: 'マイクロフォン',
      camera: 'ウェブカメラ',
      selectMicrophone: 'マイクを選択します',
      selectCam: 'ウェブカメラを選択します',
      upload: 'アップロード',
      playback: '再生',
      stopPlayback: '再生を停止',
      submit: '送信',
      startOver: '撮り直す',
      allDone: '終了です！',
      alternativeRecordSpan: 'お使いのコンピュータからビデオをアップロードしてください。<br/>',
      alrenativeRecordHref: 'Webカメラを使って録画することもできます',
      cantAnalyze:
        'ご注意 - この動画はレンダリングできませんでした。再送信するか、より一般的な画像形式（JPG、PNG、GIF、BMP）を選択してください',
      wrongFormat:
        '申し訳ありませんが、このファイル形式はサポートされていません。再送信するか、より一般的な動画形式（MP4、M4V、WEBPM）を選択してください'
    },
    cjc: {
      choose: '選択',
      pleaseChoose: '選択：',
      this: 'こちら',
      one: 'の項目',
      myChoice: 'これにする'
    },
    hm: {
      addComment: '下にコメントを追加してください。',
      commentMandatoryPlaceHolder: '必須のコメントを追加してください... ',
      commentOptionalPlaceHolder: '任意のコメントを追加してください... ',
      dragPin: '位置を変えたい場合ピンをドラッグしてください（長押しのクリック・タップしたら精密な位置）。',
      removePin: '画像以外のエリアにドラッグしたらピンを消せます。',
      editComment: 'ピンをクリック/タップしてコメントを編集します。',
      addPin: '下のパネルからピンをドラッグして選びたい部分にピンをドロップしてください。',
      addPins: '下のパネルから複数のピンをドラッグして、画像上のお好きな場所にドロップしてください。',
      leavePins: (minPoints, maxPoints) => `各種のピンを${minPoints}個以上${maxPoints}個以下にしてください。`,
      leavePinsPerPage: (minPoints, maxPoints) => `ピンを${minPoints}個以上${maxPoints}個以下にしてください。`,
      leavePinsWithOff: maxPoints => `各種のピンを最大${maxPoints}個残し、[次へ]をクリックしてスキップします。 `,
      leavePinsPerPageWithOff: maxPoints =>
        `それぞれのピンを最大 ${maxPoints}つのピンをドロップしてください。スキップしたい場合「次へ」をクリックしてください。 `,
      leavePinWithOff: '各種のピンを1個だけ残し、[次へ]をクリックしてスキップします。 ',
      leavePinPerPageWithOff: `ピンを最大1個残し、[次へ]をクリックしてスキップします。`,
      leaveExactlyPin: '各種のピンを1個残してください。 ',
      leaveExactlyPinPerPage: 'ピンを1個残してください。 ',
      leaveExactlyPins: maxPoints => `各種のピンを最大${maxPoints}個残してください。 `,
      leaveExactlyPinsPerPage: maxPoints => `最大${maxPoints}個のピンを残してください。`,
      leaveComment: '画像の下に入力してコメントを残します。 ',
      noAnswers: '回答のオプションがありません。[次へ]をクリックして続行してください。',
      outOfPins: 'ピンがない',
      pinsBehavior: '画像を横切って移動すると、1つのピンドロップでハイライトされたエリアが現れます。',
      clusters: 'それらのハイライトされたエリアのみにピンを置くことができます。',
      contentAware: 'ハイライトされたエリアの内側または外側にピンをドロップできます。'
    },
    mp: {
      expand_note: 'カーソルを合わせるか、画像をクリックして展開してください',
      rb_note: _rows => '以下の項目について{X}個の回答を選択してください: ',
      cb_note: (min, max, _rows) => {
        if (1 === min && 5000 === max) {
          return '該当するものをすべてチェックしてください:'
        } else if (min === max) {
          return `以下の項目について${min}個の回答のみを選択してください`
        } else if (min > 0 && max < 5000) {
          return `選択肢の中から当てはまるものを、1つの項目につき${min}つ) 〜${max}つ選んでください:`
        } else if (5000 === max && min > 0) {
          return `選択肢の中から当てはまるものを、1つの項目につき少なくとも ${min}つ 選んでくださ:`
        } else if (0 === min && max < 5000) {
          return `選択肢の中から当てはまるものを、1つの項目につき最大${max}つまで 選んでください:`
        } else {
          return '該当するものをすべてチェックしてください:'
        }
      }
    },
    sh: {
      note: '商品をクリックしてズームインし、ストアで購入する場合は仮想カートに追加します',
      amazonNote: '製品をクリックしてズームインし、仮想カートに追加します',
      fullCart: 'カートがいっぱいです！',
      qty: '数量',
      addToCart: 'カートに追加',
      each: '各',
      items: 'アイテム',
      deleteFromCart: '削除',
      next: '次へ',
      emptyCard: 'カートが空です',
      total: 'カート',
      clearCart: 'カートを空にする',
      backToStore: 'ストアに戻る',
      na: 'あてはまるものはない',
      maxCartCountError: max => `カートに追加する製品は、${max} 個以下にしてください`,
      scrollError: `アンケートで先に進むには、完全に左右にスクロールするようにしてください。 `,
      maxSpentError: max => `費やすのは、${max} 以下にしてください。`,
      maxProductCountError: max => `カートに追加するのは、製品あたり${max}個以下にしてください。`
    },
    rb: {
      note: '回答を 1 つだけ選択してください: '
    },
    vo: {
      note: '最後まで動画をご覧ください。'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `${min}つ選択してください：`
        } else if (min > 0 && max < 5000) {
          return `1行につき${min}つ以上${max}つまで選択してください:`
        } else if (5000 === max && min > 0) {
          return `${min}つ以上選択してください:`
        } else if (0 === min && max < 5000) {
          return `${max}つまで選択してください:`
        } else {
          return '該当するものをすべてチェックしてください:'
        }
      }
    },
    oe: {
      na: '適用できない',
      note: (min, max, optional) => {
        if (min === max) {
          return `${1 !== min ? 'いずれか' : 'ちょうど'}${min}文字 で入力してください${
            optional ? ' (オプション)' : ''
          }：`
        } else if (min > 0 && max < 5000) {
          return `${min}文字 以上${max}文字以内で入力してください${optional ? ' (オプション)' : ''}：`
        } else if (5000 === max && min > 0) {
          return `${min}文字 以上で入力してください${optional ? ' (オプション)' : ''}：`
        } else if (0 === min && max < 5000) {
          return `${max}文字 以内で入力してください${optional ? ' (オプション)' : ''}：`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: '次のフィールドに入力してください：'
    },
    mx: {
      note: '強調表示されたスライダを移動して続行してください',
      dragSlider: '右か左にドラッグして回答してくださいr'
    },
    psc: {
      dragLeftRight: '右か左にドラッグして回答してくださいr'
    },
    ps: {
      note: value => `残りの ${value} を以下の項目に配分してください`,
      allDone: '終了です！',
      total: `合計:`,
      dragSlider: '右か左にドラッグして回答してくださいr'
    },
    cx: {
      note: 'ドロップボックスを開いて回答を入力し、自動スクロールまたは手動で選択してください'
    },
    ro: {
      note: '上下にドラッグして並び替えてください：'
    },
    md: {
      note1: '最初に選択する項目をクリック/タップしてください。もう一度クリック/タップして選択を解除します。',
      note2: '次は、最後に選択する項目をクリック/タップしてください。もう一度クリック/タップして選択を解除します。',
      note3: 'ありがとうございます！次の質問に進むか、最初からやり直すには選択されていない項目をクリック/タップます。'
    },
    aro: {
      note: '各組から1つ選択してください。'
    },
    wd: {
      note: '後の値が前の値よりも大きくなるようにしてください。'
    },
    emd: {
      note: '最後まで動画をご覧ください。',
      noAnswers: '回答オプションがありません。次へをクリックして続行してください。',
      start: '開始するには、クリックして長押しします',
      resume: '再開するには、クリックして長押しします',
      continue: '準備完了です！ <br />[次へ]をクリックして続行します',
      continueMobile: '準備ができました！<br /> ここをクリックして続行',
      training: {
        session: 'トレーニングセッション',
        note: 'トレーニングを終了してください',
        moveLeft: 'ダイヤルを左端までドラッグしてください',
        moveBottom: 'ダイヤルを一番下までドラッグしてください',
        moveRight: '次に、ダイヤルを右端までドラッグしてください',
        moveTop: '次に、ダイヤルを一番上までドラッグしてください',
        success: '上出来です'
      }
    },
    sft: {
      noAnswers: '回答オプションがありません。次へをクリックして続行してください。',
      note: '直感的に正しいと思える答えをできるだけ早く回答してください',
      finish: 'これですべて完了です！<br/ >[次へ]をクリックして続行します',
      training: {
        start:
          '<p>この質問では異なる言葉が素早く表示されるので、集中力が要されます。 ' +
          '回答するには、迅速に反応する必要があります</p> <p>練習の準備ができましたか？</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `"{buttonLeft}" をタップします`
            : (mouse ? `"{buttonLeft}" をクリックします` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `「F」キーを押します` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `"{buttonRight}" をタップします`
            : (mouse ? `"{buttonRight}" をクリックします` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `「J」キーを押します` : ''),
        fail: () => '遅すぎます',
        success: () => 'ばっちりです！',
        finish: () =>
          '<p><strong> 素晴らしい！</strong></p><p>次の2〜3分は気が散らないようにしてください</p><p>準備ができたら、[次へ]をクリックして開始します.</p>'
      },
      buttons: {
        start: '開始',
        yesno: {
          left: 'はい',
          right: 'いいえ'
        },
        matches: {
          left: '一致します',
          right: '一致しません'
        },
        fits: {
          left: 'フィットします',
          right: 'フィットしません'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
